import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

function BuyCredits(props) {
    const [email, setEmail] = useState('');
    const [photo, setPhoto] = useState(null);
    const [photoPreview, setPhotoPreview] = useState(null);
    const [message, setMessage] = useState('');
    const [customMessage, setCustomMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    useEffect(() => {
        if (props.location?.state?.email) {
            setEmail(props.location.state.email);
        } else {
            setEmail('admin@newwaveconsultants.io');
        }
    }, [props.location?.state]);

    const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setPhoto(file);
            const reader = new FileReader();
            reader.onload = () => setPhotoPreview(reader.result);
            reader.readAsDataURL(file);
        } else {
            setMessage("Please upload a valid image file.");
            setMessageType('error');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !photo) {
            setMessage("Please provide both an email and a photo.");
            setMessageType('error');
            return;
        }

        const formData = new FormData();
        formData.append('email', email);
        formData.append('photo', photo);
        formData.append('customMessage', customMessage);

        try {
            const response = await fetch('/admin-email', {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();

            if (response.ok) {
                setMessage("Email sent successfully!");
                setMessageType('success');
            } else {
                setMessage(`Error: ${result.message || "Something went wrong."}`);
                setMessageType('error');
            }
        } catch (error) {
            setMessage("Failed to send email. Please try again.");
            setMessageType('error');
        }
    };

    return (
        <div>
            <img className="logo" src={logo} alt="Logo" />
            <h2>Upload Your Photo and Send Email</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    Email Address:
                    <input
                        type="email"
                        value={email}
                        readOnly
                        required
                        aria-label="Email Address"
                    />
                </label>
                <br />
                <label>
                    Upload Photo:
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handlePhotoChange}
                        required
                        aria-label="Upload Photo"
                    />
                </label>
                {photoPreview && (
                    <div>
                        <p>Preview:</p>
                        <img
                            src={photoPreview}
                            alt="Uploaded Preview"
                            style={{ maxWidth: '100%', maxHeight: '300px' }}
                        />
                    </div>
                )}
                <br />
                <label>
                    Please Provide Your Registered Email Address:
                    <textarea
                        value={customMessage}
                        onChange={(e) => setCustomMessage(e.target.value)}
                        placeholder="Email Address"
                        rows="1"
                        style={{ width: '100%' }}
                    />
                </label>
                <br />
                <button type="submit">Send Photo</button>
            </form>
            {message && (
                <p
                    className={
                        messageType === 'success' ? 'success-message' : 'error-message'
                    }
                >
                    {message}
                </p>
            )}
            <footer>
                <div>Powered by</div>
                <img className="logo2" src={logo2} alt="Logo 2" />
                <div>New Wave Consulting Group</div>
            </footer>
        </div>
    );
}

export default BuyCredits;
